import { zAbstractDeductionTemplate } from "./zAbstractDeductionTemplate";

export const zCreateAbstractContractorDeductionTemplate =
  zAbstractDeductionTemplate
    .pick({
      companyID: true,
      contractorID: true,
      deduction_type: true,
      custom_name: true,
      effective_start_date: true,
    })
    .required()
    .merge(
      zAbstractDeductionTemplate
        .pick({
          effective_end_date: true,
          external_id: true,
          zeal_managed: true,
          webhook_id: true,
        })
        .partial()
    );
